import { SystemType } from '@/app/store/systemStore'

export const getSystemDisplayName = (system: SystemType): string => {
  if (!system) return ''
  return system.charAt(0).toUpperCase() + system.slice(1)
}
